import(/* webpackMode: "eager" */ "/home/node/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/home/node/app/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/app/[locale]/(header-footer)/glossary/HeadingsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollProvider"] */ "/home/node/app/src/context/ScrollProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["VisibleVersionProvider"] */ "/home/node/app/src/context/VisibleVersionProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/ArticleItem/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/BreadcrumbsWrap/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/ContentHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/LanguageOptionsSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/containers/layout/TwoColumn.tsx");
